import { Button } from "@material-ui/core";
import Delete from "@material-ui/icons/Delete";
import { memo, MouseEvent } from "react";

import styles from "./DeleteIcon.module.scss";

type DeleteIconProps = {
  readonly onClick: (e: MouseEvent<HTMLButtonElement>) => void;
};

export const DeleteIcon = memo<DeleteIconProps>(({ onClick }) => (
  <Button
    endIcon={<Delete />}
    onClick={onClick}
    classes={{
      root: styles.wrapper,
      label: styles.label,
    }}
  >
    Usuń
  </Button>
));
